import * as React from "react";
import { useNotify, useRefresh } from "react-admin";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import { useAppDataProvider } from "../../../../dataprovider";
import { Box, ButtonGroup, IconButton, Tooltip, Zoom } from "@material-ui/core";
import { AccessTime, Create, ThumbUpAlt } from "@material-ui/icons";
import { ConfirmButton } from "../../../../Components/ConfirmButton";
import { useAccessControl, useAuth } from "@airborne/react-admin";
import { DetailButton } from "../../../../Components/DetailButton";
import { SourceRequestOrder } from "../../Constant/Source";

export const AcceptColumn = (props: any) => {
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const { user } = useAuth();
  const { canCreate, canEdit, canRead, hasAccess } = useAccessControl(SourceRequestOrder);

  const acceptButtonClick = () => e => {
    dataProvider
      .getOne("requestorders/", { id: props.record.id })
      .then(response => {
        response.data.requestStatus = RequestStatus.Status24;

        dataProvider
          .updateRequestOrder(response.data)
          .then(result => {
            notify(`Record updated`, "success", false, true);
          })
          .catch(error => {
            notify(`Error : ${error}`, "error", false, true);
          })
          .finally(() => {
            refresh();
          });
      })
      .catch(error => {});
  };

  const AcceptButton = () => {
    return (
      <ConfirmButton
        {...props}
        variant="text"
        style={{
          color: "#12824C",
        }}
        size="medium"
        click={acceptButtonClick()}
      >
        <Tooltip TransitionComponent={Zoom} title="Accept">
          <ThumbUpAlt />
        </Tooltip>
      </ConfirmButton>
    );
  };

  const rddDelayButtonClick = () => e => {
    dataProvider
      .getOne("requestorders/", { id: props.record.id })
      .then(response => {
        response.data.isRddDelayed = true;

        dataProvider
          .updateRequestOrder(response.data)
          .then(result => {
            notify(`Record updated`, "success", false, true);
          })
          .catch(error => {
            notify(`Error : ${error}`, "error", false, true);
          })
          .finally(() => {
            refresh();
          });
      })
      .catch(error => {});
  };

  const RddDelayedButton = () => {
    return (
      <ConfirmButton
        {...props}
        variant="text"
        style={{
          color: "#DC143C",
        }}
        size="medium"
        click={rddDelayButtonClick()}
      >
        <Tooltip TransitionComponent={Zoom} title="Rdd Delayed!">
          <AccessTime />
        </Tooltip>
      </ConfirmButton>
    );
  };

  const RemarkButton = () => {
    return (
      <IconButton style={{ width: 40 }} onClick={remarkOnClick}>
        <Tooltip TransitionComponent={Zoom} title="Core Last Update">
          <Create />
        </Tooltip>
      </IconButton>
    );
  };
  const DetailsButton = () => {
    return <DetailButton record={props.record} resource={"requestorders"} />;
  };

  const remarkOnClick = e => {
    e.stopPropagation();
    props?.remarkAddClick?.(props?.record);
  };

  return (
    <Box style={{ flex: 1, flexDirection: "row" }}>
      <ButtonGroup variant="text" size="small">
        <DetailsButton />
        {user?.isCustomer === false && canCreate && (
          <>
            <AcceptButton />
            <RemarkButton />

            {!props.record.isRddDelayed && <RddDelayedButton />}
          </>
        )}
      </ButtonGroup>
    </Box>
  );
};
export default AcceptColumn;
